export const OrdenesComprasReporteLang = {
    // ENCABEZADO
    TituloReporte: {
        es: 'Orden de Compras',
        en: 'Purchase Order',
    },
    direccionE: {
        es: 'Dirección de Envío: ',
        en: 'Address Ship To: ',
    },
    direccion: {
        es: 'Dirección: ',
        en: 'Address: ',
    },


    // TABLAS
    proveedor: {
        es: 'Proveedor: ',
        en: 'Vendor: ',
    },
    envioA: {
        es: 'Envío a ',
        en: 'Ship To: ',
    },
    nombre: {
        es: 'Nombre: ',
        en: 'Name: ',
    },
    telefono: {
        es: 'Telefono: ',
        en: 'Phone: ',
    },

// TABLA PRINCIPAL
    cantidad: {
        es: 'CANT.',
        en: 'QTY.',
    },
    codigo: {
        es: 'CÓDIGO',
        en: 'CODE',
    },
    producto: {
        es: 'PRODUCTO',
        en: 'PRODUCT',
    },
    unidad: {
        es: 'UNIDAD',
        en: 'UNIT',
    },
    precio: {
        es: 'PRECIO',
        en: 'PRICE',
    },
    isv: {
        es: 'ISV',
        en: 'TAX',
    },
    descuento: {
        es: 'DESC.',
        en: 'DISC.',
    },
    descripcion: {
        es: 'DESCRIPCION.',
        en: 'DESCRIPTION.',
    },


    desc: {
        es: 'Desc.',
        en: 'Disc.',
    },
    fletes: {
        es: 'Fletes.',
        en: 'Freigths.',
    },
    otros: {
        es: 'Otros.',
        en: 'Others.',
    },

    terminosPago: {
        es: 'Términos de Pago: ',
        en: 'Payment Terms: ',
    },
    terminosInco: {
        es: 'Términos Inco: ',
        en: 'InconTerms: ',
    },
    comentario: {
        es: 'Comentario: ',
        en: 'Comment: .',
    },

    // FIRMAS
    deptoCompras: {
        es: 'Firma Autorizada',
        en: 'Authorized Signature',
    },



    // FOOTER
    fecha: {
        es: 'Fecha: ',
        en: 'Date: ',
    },
    original: {
        es: 'Original: Proveedor / Operaciones (Solicitud de Compra)',
        en: 'Original: Supplier / Operations (Purchase Request) ',
    },
    copia: {
        es: 'Copia 1: Contabilidad',
        en: 'Copy 1: Accounting ',
    },
    copia2: {
        es: 'Copia 2: Desarrollo de Telas / Bodega',
        en: 'Copy 2: Fabric Development / Warehouse ',
    },
    textFinal: {
        es: 'Esta orden de compra no será válida sin la firma y sello autorizado de: CAMDEN SPINNING MILLS S.A. DE C.V.  El pago no se realizará en función de los artículos aceptados por nuestro departamento de control de calidad. El número de orden de compra debe reflejarse en todas las facturas y listas de empaque.',
        en: 'This purchase order will not be valid without authorized sign and seal from: CAMDEN SPINNING MILLS S.A. DE C.V.  Payment will not be done based on accepted items by our quality control department. Purchase Order number must be reflected in all invoices and packing lists.',
    },
    textFinal2: {
        es: 'Esta orden de compra no será válida sin la firma y sello autorizado de: CAMDEN SPINNING MILLS S.A. DE C.V.  El pago no se realizará en función de los artículos aceptados por nuestro departamento de control de calidad. El número de orden de compra debe reflejarse en todas las facturas y listas de empaque.',
        en: 'This purchase order will not be valid without authorized sign and seal from: CAMDEN SPINNING MILLS S.A. DE C.V.  Payment will not be done based on accepted items by our quality control department. Purchase Order number must be reflected in all invoices and packing lists.',
    },
    textFinal3: {
        es: 'Esta orden de compra no será válida sin la firma y sello autorizado de: CAMDEN SPINNING MILLS S.A. DE C.V.  El pago no se realizará en función de los artículos aceptados por nuestro departamento de control de calidad. El número de orden de compra debe reflejarse en todas las facturas y listas de empaque.',
        en: 'This purchase order will not be valid without authorized sign and seal from: CAMDEN SPINNING MILLS S.A. DE C.V.  Payment will not be done based on accepted items by our quality control department. Purchase Order number must be reflected in all invoices and packing lists.',
    },
}